var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.527 3.08A.65.65 0 0 0 10 2.8a.63.63 0 0 0-.527.28l-4.06 5.906L2.098 5.61a.64.64 0 0 0-.701-.142.65.65 0 0 0-.289.241.66.66 0 0 0-.108.365v8.508c0 .694.27 1.36.753 1.851.482.491 1.136.767 1.818.767H16.43c.682 0 1.336-.276 1.818-.767a2.64 2.64 0 0 0 .753-1.85v-8.51a.66.66 0 0 0-.108-.364.632.632 0 0 0-.99-.1l-3.315 3.377z",
    clipRule: "evenodd"
  })));
};
export default SvgCrown;